import { Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators} from "@angular/forms";
import { IonContent } from "@ionic/angular";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Navigator } from "src/app/components/menu/navigator";
import { CustomerModel } from "src/app/models/customer-model";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { ConfigService } from "src/app/services/config/config.service";
import { noWhitespaceOnlyValidator } from "src/app/services/customFormValidators";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { WebservicesService } from "src/app/services/webservices/webservices.service";

@Component({
  selector: "app-security-question",
  templateUrl: "./security-question.component.html",
  styleUrls: ["./security-question.component.scss"],
})

export class SecurityQuestionComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  public error: any = null;
  public customer: CustomerModel;
  public infoForm: FormGroup;
  public securityQuestion: AbstractControl;
  public securityAnswer: AbstractControl;
  public secondSecurityQuestion: AbstractControl;
  public secondSecurityAnswer: AbstractControl;
  public selectedSecurityQuestion: string;
  public selectedSecondSecurityQuestion: string;
  public securityQuestions: any[];
  public secondSecurityQuestions: any[];

  constructor(
    private authService: AuthenticationService,
    private configService: ConfigService,
    public successMessageService: SuccessMessageService,
    private userSession: UserSessionService,
    private navigator: Navigator,
    private webservice: WebservicesService
  ) {
    this.userSession.getCustomer().subscribe((customer) => {
      if (customer) {
        this.customer = customer;
      }
    });
    this.userSession.refreshCustomer();
  }

  ngOnInit() {
    this.infoForm = new FormGroup({
      securityQuestion: new FormControl("", [Validators.required]),
      securityAnswer: new FormControl("", [
        Validators.required,
        noWhitespaceOnlyValidator,
      ]),
      secondSecurityQuestion: new FormControl("", [Validators.required]),
      secondSecurityAnswer: new FormControl("", [
        Validators.required,
        noWhitespaceOnlyValidator,
      ]),
    });

    this.securityQuestion = this.infoForm.get("securityQuestion");
    this.securityAnswer = this.infoForm.get("securityAnswer");
    this.secondSecurityQuestion = this.infoForm.get("secondSecurityQuestion");
    this.secondSecurityAnswer = this.infoForm.get("secondSecurityAnswer");
  }

  ionViewWillEnter() {
    this.successMessageService.clearMessage();
    this.error = null;

    this.callGetFormMetadata().subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.securityQuestions = response.payload.security_questions["1"];
          this.selectedSecurityQuestion = this.customer.securityQuestion;

          this.secondSecurityQuestions =
            response.payload.security_questions["2"];

          for (let i: number = 0; i < this.securityQuestions.length; i++) {
            if (this.customer.securityQuestion == this.securityQuestions[i]) {
              this.selectedSecurityQuestion = this.securityQuestions[i];
            }
          }

          for (
            let i: number = 0;
            i < this.secondSecurityQuestions.length;
            i++
          ) {
            if (
              this.customer.secondSecurityQuestion ==
              this.secondSecurityQuestions[i]
            ) {
              this.selectedSecondSecurityQuestion =
                this.secondSecurityQuestions[i];
            }
          }
        }
      },
      (error) => {
        console.error("callGetFormMetadata ", error);
      }
    );
  }

  ionViewWillLeave() {
    if (this.configService.getConfig().KYC_CHECK_PLAY == "1" &&  this.customer.isIncomplete()) {
      this.navigator.navigateTo("LogoutPage");
    }
  }

  protected onSubmit(): any {

    this.infoForm.value.clientapp = this.configService.getClientApp();

    this.authService.callSetSecurityQuestions(this.infoForm.value).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.successMessageService.setMessage(
            "Your account has been updated!"
          );
          this.userSession.refreshCustomer();
          this.error = null;
          this.content.scrollToTop();
        }
      },
      (error) => {

        switch (error.getErrorCode().toUpperCase()) {
          case "AGE_VERIFICATION_FAILED":
            error.setErrorMessage("Form has errors, please see below");
            break;
          case "ALREADY_HAS_ACCOUNT":
            error.setErrorMessage(
              "It looks like you may have an account with us already."
            );
            break;
          case "CUSTOMER_IN_BLACKLIST":
            error.setErrorMessage(
              "Cannot create account please contact customer support."
            );
            break;
          case "GOVERNMENT_ID_ALREADY_EXISTS":
            error.setErrorMessage(
              "Cannot create account please verify your data. Contact support if the issue continues."
            );
            break;
          case "INVALID_BIRTHDATE":
            error.setErrorMessage("The birthdate entered is invalid");
            break;
          case "BAD_CONTENT":
            error.setErrorMessage(error.getErrorMessage());
            break;
          default:
            error.setErrorMessage(error.getErrorMessage());
            break;
        }
        this.successMessageService.clearMessage();
        this.error = error;
        this.content.scrollToTop(10);
      }
    );
  }

  protected callGetFormMetadata(): Observable<any> {
    return this.webservice.get("configuration/get-form-metadata").pipe(
      catchError((error) => {
        console.error("callGetFormMetadata ", error);
        throw error;
      })
    );
  }
}
